export const degreeListConvertion = ({
  listOfDegree,
  parentNameParam = 'name',
  parentValueParam = 'id',
  pathName = 'degreeStreamMap',
  selectedIds = [],
  isEditActiveRole = false,
}) => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        title: item[parentNameParam],
        value: item[parentValueParam],
        disabled: isEditActiveRole
          ? selectedIds?.includes(item[parentValueParam])
          : false,
        children: item[pathName]?.map(data => {
          return {
            title:
              pathName === 'streams'
                ? data?.name
                : item?.shortForm
                ? `${item?.shortForm} - ${data?.stream?.name}`
                : data?.stream?.name,
            value: data[parentValueParam],
            streamData: {
              id: data[parentValueParam],
              streamId: data?.stream?.id,
            },
            disabled: isEditActiveRole
              ? selectedIds?.includes(data[parentValueParam])
              : false,
          }
        }),
      }
    })
  )
}

export const degreeSearchConversion = ({
  listOfDegree,
  parentNameParam = 'name',
  parentValueParam = 'id',
  pathName = 'degreeStreamMap',
  selectedIds = [],
  isEditActiveRole = false,
}) => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        title: item?._source?.['degreeName'],
        value: item?._source?.['degreeId'],
        disabled: isEditActiveRole
          ? selectedIds?.includes(item?._source?.['degreeId'])
          : false,
        children: item?.inner_hits?.streams?.hits?.hits?.map(data => {
          return {
            title:
              item?._source?.['degreeShortForm'] +
              '-' +
              data?._source?.streamName,
            value: data?._source?.degreeStreamId,
            streamData: {
              id: data?._source?.degreeStreamId,
              streamId: data?._source?.streamId,
            },
            disabled: isEditActiveRole
              ? selectedIds?.includes(data?._source?.degreeStreamId)
              : false,
          }
        }),
      }
    })
  )
}
